<template>
    <el-row class="container">
        <el-col :span="24" class="header">
            <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
                <!--{{collapsed?'':sysName}}-->
            </el-col>
            <el-col :span="4">
                <div class="tools" @click.prevent="collapse">
                    <i class="fa fa-align-justify"></i>
                </div>
            </el-col>
            <el-col :span="8" class="userinfo">
                <el-dropdown trigger="hover" class="pull-right">
                    <span class="el-dropdown-link userinfo-inner"><i class="fa fa-user-circle-o user-icon"
                                                                     aria-hidden="true"></i>{{sysUserName}}</span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="logout">Logout</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-select class="pull-right" size="small" placeholder="Company" @change="changeDoctor" v-model="currentCompany" v-if="user.roleId==2||user.roleId==3">
                    <el-option v-for="(doctor,index) in doctors" :key="index" :label="doctor.userName" :value="doctor.userNo"></el-option>
                </el-select>

            </el-col>
        </el-col>
        <el-col :span="24" class="main">
            <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
                <!--导航菜单-->
                <el-menu :default-active="$route.path" class="el-menu-vertical-demo el-menu-open"
                         unique-opened router v-show="!collapsed">
                    <template v-for="(item,index) in getRoutes" v-if="!item.hidden">
                        <el-submenu :index="index+''" v-if="!item.leaf">
                            <template slot="title">
                                <div class="el-menu-item">
                                    <el-col :span="10" style="text-align: center"><i style="margin-left: 12px"
                                                                                     :class="item.iconCls"></i></el-col>
                                    <el-col :span="14" style="text-align: left">{{item.name}}</el-col>
                                </div>
                            </template>
                            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path"
                                          v-if="!child.hidden">
                                <el-col :span="10" style="text-align: center"><i :class="child.iconCls"></i></el-col>
                                <el-col :span="14" style="text-align: left">{{child.name}}</el-col>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
                            <el-col :span="10" style="text-align: center"><i style="margin-left: 12px"
                                                                             :class="item.iconCls"></i></el-col>
                            <el-col :span="14" style="text-align: left">{{item.children[0].name}}</el-col>
                        </el-menu-item>
                    </template>
                </el-menu>
                <!--导航菜单-折叠后-->
                <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
                    <li v-for="(item,index) in getRoutes" v-if="!item.hidden" class="el-submenu item">
                        <template v-if="!item.leaf">
                            <div class="el-submenu__title el-menu-item" style="padding-left: 20px;"
                                 @mouseover="showMenu(index,true)"
                                 @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
                            <ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)"
                                @mouseout="showMenu(index,false)">
                                <li v-for="child in item.children" v-if="!child.hidden" :key="child.path"
                                    class="el-menu-item" style="padding-left: 40px;"
                                    :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">
                                    {{child.name}}
                                </li>
                            </ul>
                        </template>
                        <template v-else>
                    <li class="el-submenu">
                        <div class="el-submenu__title el-menu-item"
                             style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;"
                             :class="$route.path==item.children[0].path?'is-active':''"
                             @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
                    </li>
</template>
</li>
</ul>
</aside>
<section class="content-container">
    <div class="grid-content bg-purple-light">
        <el-col :span="24" class="breadcrumb-container">
            <p class="title">{{$route.name}}</p>
            <!--<el-breadcrumb separator="/" class="breadcrumb-inner">
                <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                    {{ item.name }}
                </el-breadcrumb-item>
            </el-breadcrumb>-->
        </el-col>
        <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
                <router-view ref="child" :current-company="currentCompany"></router-view>
            </transition>
        </el-col>
    </div>
</section>
</el-col>
</el-row>
</template>

<script>
    import {url} from "../globalVar"
    import {logout} from "../api/securityService";
    import {getNurseDoctor} from "../api/memberService";
    import ElOption from "element-ui/packages/select/src/option";

    export default {
        components: {ElOption},
        computed: {
            getRoutes() {
                return global.antRouter
            }
        },
        data() {
            return {
                currentCompany:"",
                user:{},
                doctors:[],
                sysName: 'BSCI',
                collapsed: false,
                sysUserName: '',
                sysUserAvatar: '',
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                }
            }
        },
        methods: {
            changeDoctor(){
                this.$refs.child.$emit('changeDoctor',this.currentCompany);
                window.sessionStorage.setItem("currentCompany", this.currentCompany)
            },
            getDoctors(){
                getNurseDoctor().then((res)=>{
                    if(res.status===200){
                        this.doctors = res.result;
                        if(this.doctors.length>0){
                            let currentCompany = window.sessionStorage.getItem("currentCompany");
                            if(!currentCompany){
                                window.sessionStorage.setItem("currentCompany", this.doctors[0].userNo);
                                this.currentCompany = res.result[0].userNo;
                            }else{
                                this.currentCompany = currentCompany;
                            }
                        }
                    }
                })
            },
            //退出登录
            logout: function () {
                this.$confirm('Are you sure?', 'Warning', {
                    //type: 'warning'
                }).then(() => {
                    logout().then((res)=>{
                        sessionStorage.removeItem('user');
                        sessionStorage.removeItem('authorization');
                        sessionStorage.removeItem('currentCompany');
                        window.location.href = url;
                    }).catch(() => {
                        sessionStorage.removeItem('user');
                        sessionStorage.removeItem('authorization');
                        sessionStorage.removeItem('currentCompany');
                        window.location.href = url;
                    });
                }).catch(() => {

                });


            },
            //折叠导航栏
            collapse: function () {
                this.collapsed = !this.collapsed;
            },
            showMenu(i, status) {
                this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
            }
        },
        mounted() {
            let user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
                this.user = user;
                this.sysUserName = user.username || '';
                if(user.roleId==='2'||user.roleId==="3"){
                    this.getDoctors();
                }
            }
        }
    }

</script>

<style scoped lang="scss">

    .container {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;
        background-color: #fff;

        .content-container {
            padding: 0 !important;

            .content-wrapper {
                padding: 20px;
            }
        }

        .el-menu-open {
            width: 230px !important;
        }

        .user-icon {
            width: 50px;
            font-size: 30px;
            text-align: center;
            line-height: 60px;
        }

        .el-menu-item {
            color: #FFF;
            height: 56px;
            background-color: #439edc;
            padding: 0 !important;
            font-size: 18px;

            .el-col-10 {
                font-weight: normal;
                font-size: 16px;
                text-align: center;
            }
        }

        .breadcrumb-container {
            background-color: #f3f3f3;
            padding: 0 20px;

            p {
                font-size: 18px;
            }
        }

        .el-submenu:hover {
            background-color: #439edc;
        }

        .el-menu-item.is-active {
            color: #000000;
            background-color: #346fb3;
        }

        .header {
            height: 60px;
            line-height: 60px;
            background:#439edc;
            color: #fff;

            .userinfo {
                text-align: right;
                padding-right: 35px;
                float: right;

                .userinfo-inner {
                    cursor: pointer;
                    color: #fff;

                    img {
                        width: 40px;
                        height: 40px;
                        border-radius: 20px;
                        margin: 10px 0px 10px 10px;
                        float: right;
                    }
                }
            }
            .logo.logo-collapse-width{
                background: none;
            }
            .logo {
                //width:230px;
                background: url("../assets/logo.png") no-repeat;
                background-size: 230px 60px;
                height: 60px;
                font-size: 22px;
                padding-left: 20px;
                padding-right: 20px;
                border-color: #fff;
                border-bottom: 1px solid #746477;
                cursor: pointer;
                /*border-bottom-width: 1px;*/
                /*border-right-style: solid;*/
                /*border-bottom-style: solid;*/
                text-align: center;

                img {
                    width: 40px;
                    float: left;
                    margin: 10px 10px 10px 18px;
                }

                .txt {
                    color: #fff;
                }
            }

            .logo-width {
                width: 230px;
            }

            .logo-collapse-width {
                width: 60px
            }

            .tools {
                padding: 0px 23px;
                width: 14px;
                height: 60px;
                line-height: 60px;
                cursor: pointer;
            }
        }

        .main {
            display: flex;
            // background: #324057;
            position: absolute;
            top: 60px;
            bottom: 0px;
            overflow: hidden;

            aside {
                flex: 0 0 230px;
                width: 230px;
                // position: absolute;
                // top: 0px;
                // bottom: 0px;
                .el-menu {
                    background-color: #439edc;
                    text-align: center;
                    height: 100%;
                }

                .collapsed {
                    width: 60px;

                    .item {
                        position: relative;
                    }

                    .submenu {
                        position: absolute;
                        top: 0px;
                        left: 60px;
                        z-index: 99999;
                        height: auto;
                        display: none;
                    }

                }
            }

            .menu-collapsed {
                flex: 0 0 60px;
                width: 60px;
            }

            .menu-expanded {
                flex: 0 0 230px;
                width: 230px;
            }

            .content-container {
                // background: #f1f2f7;
                flex: 1;
                // position: absolute;
                // right: 0px;
                // top: 0px;
                // bottom: 0px;
                // left: 230px;
                overflow-y: scroll;
                padding: 20px;

                .breadcrumb-container {
                    //margin-bottom: 15px;
                    .title {
                        width: 200px;
                        float: left;
                        color: #475669;
                    }

                    .breadcrumb-inner {
                        float: right;
                    }
                }

                .content-wrapper {
                    background-color: #fff;
                    box-sizing: border-box;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Home.vue?03812623